import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { PageHeaderComponent } from './components/page-header/page-header.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule
  ],
  declarations: [
    PageHeaderComponent,
    SidebarComponent],
  exports:   [
    PageHeaderComponent,
    SidebarComponent],
})
export class SharedModule { }



// WEBPACK FOOTER //
// D:/a/1/s/src/app/shared/shared.module.ts